import React from 'react'
// libs
import { Helmet } from 'react-helmet-async'
import { useMutation } from '@apollo/client/react'
// components
import NavigationSidebar from 'components/UI/NavigationSidebar'
import MainLayoutContainer from 'containers/MainLayout/index'
import BusinessEntityModal from 'components/Modals/BusinessEntityModal'
import BusinessActivitiesTree from 'components/PageComponents/Settings/BusinessActivities/components/Tree/index'
import { CreateBusinessActivityButton } from 'components/CTAs'
import { LayoutContainerInnerWrapper } from 'themes/views/layouts'
// graphql
import { BUSINESS_ACTIVITIES_SELECT_QUERY } from 'graphql/businessActivity/queries'
import {
  BUSINESS_ACTIVITY_CREATE_MUTATION,
  BUSINESS_ACTIVITY_UPDATE_MUTATION
} from 'graphql/businessActivity/mutations'
// context
import { BusinessActivitiesAPIContext } from 'containers/BusinessActivities/layers/API'
// constants
import { ENTITIES } from 'constants/entities'
// utils
import { settingsSidebarConfig } from 'layouts/SettingsLayout/config'
import { businessActivityProps } from 'components/FormElements/ReduxForm/ReduxEntitySelect/utils'

const BusinessActivities: React.FC = () => {
  const [createMutation] = useMutation(BUSINESS_ACTIVITY_CREATE_MUTATION)
  const [updateMutation] = useMutation(BUSINESS_ACTIVITY_UPDATE_MUTATION)

  const { refetch, lastPosition, isLoading } = React.useContext(BusinessActivitiesAPIContext)

  return (
    <>
      <Helmet>
        <title>Skefto - Business Activities</title>
      </Helmet>
      <MainLayoutContainer isLoading={isLoading} CTA={<CreateBusinessActivityButton />}>
        <NavigationSidebar config={settingsSidebarConfig} />
        <LayoutContainerInnerWrapper>
          <BusinessActivitiesTree />
        </LayoutContainerInnerWrapper>
      </MainLayoutContainer>

      <BusinessEntityModal
        {...businessActivityProps}
        refetch={refetch}
        lastPosition={lastPosition}
        createMutation={createMutation}
        updateMutation={updateMutation}
        entityType={ENTITIES.BUSINESS_ACTIVITY}
        query={BUSINESS_ACTIVITIES_SELECT_QUERY}
      />
    </>
  )
}

export default BusinessActivities
